import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
})
export class ErrorMessageComponent {
  @Output() dismissed = new EventEmitter<boolean>();
  @Input() message: any;

  dismiss() {
    this.dismissed.emit(true);
  }
}
